export * from './apartment-variants';
